import { Switch, Route } from 'react-router-dom'

//商品管理
import Error404 from '@/views/404'
//工单管理
import { SystemOrder } from '@/views/systemSet/order/view' //车辆维保工单
import { SystemOrderDetails } from '@/views/systemSet/order/view/details' //车辆维保工单详情
//车辆三检
import { ThreeInspectionScheduling } from '@/views/threeInspection/scheduling/view' //三检排班
import { ThreeInspectionLedger } from '@/views/threeInspection/ledger/view' //三检台账
import { ThreeInspectionLedgerDetails } from '@/views/threeInspection/ledger/view/details' //三检台账详情
import { ThreeInspectionDanger } from '@/views/threeInspection/danger/view' //隐患台账
import { ThreeInspectionDangerDetails } from '@/views/threeInspection/danger/view/details' //隐患台账详情
import { ThreeInspectionFatigueDriving } from '@/views/threeInspection/fatigueDriving/view' //疲劳检测
import { ThreeInspectionAlcoholDriving } from '@/views/threeInspection/alcoholDriving/view' //酒精检测
//系统设置
import { BaseVehicle } from '@/views/base/vehicle/view' //车辆管理
import { BaseTrailer } from '@/views/base/trailer/view' //挂车管理
import { BaseDriver } from '@/views/base/driver/view' //司机管理
import { BaseSupercargo } from '@/views/base/supercargo/view' //押运员管理
import { BaseAdmin } from '@/views/base/admin/view' //管理员管理
import { BaseInspector } from '@/views/base/inspector/view' //巡查员管理
import { BaseMaintenanceTechnician } from '@/views/base/maintenanceTechnician/view' //维修技师管理
import { BaseRoutine } from '@/views/base/routine/view' //路线管理
import { BaseThreeTestItem } from '@/views/base/threeTestItem/view' //三检项目
import { BaseAuth } from '@/views/base/auth/view' //账号设置
import { BaseFleet } from '@/views/base/fleet/view' //账号设置
import { BaseCompany } from '@/views/base/company/view' //账号设置
import { BaseTiredSetting } from '@/views/base/tiredSetting/view' //账号设置
import Meetings from '@/views/base/meetings/view' //车辆管理
import Notice from '@/views/base/notice/view' //车辆管理

import useGlobalModel from '@/model/globalModel'

function AppRoute() {
    const {
        user: { accountName, userType },
    } = useGlobalModel(({ user }) => [user])
    return (
        <Switch>
            {/* 车辆维保工单 */}
            {accountName !== 'lddqkl' && <Route exact={true} path={'/systemSet/order'} key="2-1" component={SystemOrder} />}
            {accountName !== 'lddqkl' && <Route exact={true} path={'/systemSet/order/look'} key="2-1-1" component={SystemOrderDetails} />}

            {/* 三检排班 */}
            <Route exact={true} path={'/threeInspection/scheduling'} key="3-1" component={ThreeInspectionScheduling} />
            {/* 三检台账 */}
            <Route exact={true} path={'/threeInspection/ledger'} key="3-2" component={ThreeInspectionLedger} />
            <Route exact={true} path={'/threeInspection/ledger/look'} key="3-2-1" component={ThreeInspectionLedgerDetails} />
            {/* 隐患台账 */}
            <Route exact={true} path={'/threeInspection/danger'} key="3-3" component={ThreeInspectionDanger} />
            <Route exact={true} path={'/threeInspection/danger/look'} key="3-3-1" component={ThreeInspectionDangerDetails} />
            {/* 疲劳检测 */}
            <Route exact={true} path={'/threeInspection/fatigueDriving'} key="3-4" component={ThreeInspectionFatigueDriving} />
            {/* 酒精检测 */}
            <Route exact={true} path={'/threeInspection/alcoholDriving'} key="3-5" component={ThreeInspectionAlcoholDriving} />
            {/* 车辆管理 */}
            <Route exact={true} path={'/base/vehicle'} key="4-1" component={BaseVehicle} />
            {/* 挂车管理 */}
            <Route exact={true} path={'/base/trailer'} key="4-2" component={BaseTrailer} />
            {/* 司机管理 */}
            <Route exact={true} path={'/base/driver'} key="4-3" component={BaseDriver} />
            {/* 押运员管理 */}
            <Route exact={true} path={'/base/supercargo'} key="4-4" component={BaseSupercargo} />
            {/* 维修技师管理 */}
            <Route exact={true} path={'/base/maintenanceTechnician'} key="4-5" component={BaseMaintenanceTechnician} />
            {/* 管理员管理 */}
            {userType === '超级管理员' && <Route exact={true} path={'/base/admin'} key="4-5" component={BaseAdmin} />}
            {/* 巡查员管理 */}
            {userType === '超级管理员' && <Route exact={true} path={'/base/inspector'} key="4-15" component={BaseInspector} />}
            {/* 路线管理 */}
            <Route exact={true} path={'/base/routine'} key="4-6" component={BaseRoutine} />
            {/* 三检项目 */}
            <Route exact={true} path={'/base/threeTestItem'} key="4-7" component={BaseThreeTestItem} />
            {/* 账号设置 */}
            <Route exact={true} path={'/base/auth'} key="4-8" component={BaseAuth} />
            {/* 车辆现场管理 */}
            <Route exact={true} path={'/base/fleet'} key="4-9" component={BaseFleet} />
            {/* 产权归属公司管理 */}
            <Route exact={true} path={'/base/company'} key="4-10" component={BaseCompany} />
            {/* 疲劳检测设置 */}
            <Route exact={true} path={'/base/tiredSetting'} key="4-11" component={BaseTiredSetting} />
            {/* 会议管理 */}
            <Route exact={true} path={'/base/meetings'} key="4-12" component={Meetings} />
            {/* 公告管理 */}
            <Route exact={true} path={'/base/notice'} key="4-13" component={Notice} />
            <Route exact={true} path={'/*'} key="404" component={Error404} />
        </Switch>
    )
}

export default AppRoute
